import { Option } from "components/product-collection/footer/components/left-side/manage-distribution-modal/components/select";
import { COLLECTIONS } from "constants/action-types";

export const openDistributionModal = () => ({
    type: COLLECTIONS.COLLECTION.DISTRIBUTION.MODAL.OPEN,
});

export const closeDistributionModal = () => ({
    type: COLLECTIONS.COLLECTION.DISTRIBUTION.MODAL.CLOSE,
});

export type Distribution = Option | undefined;

export const setSelectedDistribution = (distribution: Distribution) => ({
    type: COLLECTIONS.COLLECTION.DISTRIBUTION.SELECT,
    payload: distribution,
});
